import { render, staticRenderFns } from "./NewDeviation.vue?vue&type=template&id=bb9e9282&scoped=true&"
import script from "./NewDeviation.vue?vue&type=script&lang=js&"
export * from "./NewDeviation.vue?vue&type=script&lang=js&"
import style0 from "./NewDeviation.vue?vue&type=style&index=0&id=bb9e9282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9e9282",
  null
  
)

/* custom blocks */
import block0 from "./NewDeviation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports